import axios from 'axios';
import BaseAPI from './base/base-api';

class StickAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'stick';
}

export default new StickAPI();